/* AIWD header menu enhancer
   - Removes Horizon's mega-menu chrome, rebuilding each dropdown as a simple themed list.
   - Gives every dropdown link its own unique, themed icon.
   - Hides the "More" overflow control.
   Idempotent; safe to run repeatedly as the header hydrates. */
(function () {
  // icon library: key -> {c: themed color, p: inner SVG markup (24x24 viewBox)}
  var A = {
    // service / collections
    '/pages/services': { c: '#1D5CFF', p: '<path d="M3 4h18v6H3zM3 14h8v6H3zM15 14h6v6h-6z"/>' },
    '/pages/seo-ai-search-fort-myers': { c: '#0FB5A6', p: '<circle cx="10.5" cy="10.5" r="6"/><path d="m19 19-4-4"/><path d="M18 2.5l.8 1.9 1.9.8-1.9.8L18 8l-.8-1.9L15.3 5.2l1.9-.8Z"/>' },
    '/pages/online-store-shopify-design': { c: '#1D5CFF', p: '<path d="M3 4h2l2.4 11h9.8l2.2-8H6"/><circle cx="9.5" cy="19" r="1.5"/><circle cx="17" cy="19" r="1.5"/>' },
    '/pages/my-project': { c: '#7A5AF8', p: '<circle cx="12" cy="8" r="3.2"/><path d="M5.5 20a6.5 6.5 0 0 1 13 0Z"/>' },
    '/collections/website-builds': { c: '#1D5CFF', p: '<path d="M13 2 4 14h6l-1 8 9-12h-6l1-8Z"/>' },
    '/collections/packages': { c: '#7A5AF8', p: '<path d="M21 8 12 3 3 8l9 5 9-5Z"/><path d="M3 8v8l9 5 9-5V8"/><path d="M12 13v8"/>' },
    '/collections/search-plans': { c: '#0FB5A6', p: '<circle cx="11" cy="11" r="7"/><path d="m20 20-3.4-3.4"/>' },
    '/collections/add-ons': { c: '#F2A93B', p: '<path d="M12 5v14M5 12h14"/>' },
    '/pages/website-design-prices': { c: '#C2410C', p: '<path d="M20.6 13.4 11 3.8H4v7l9.6 9.6a1.4 1.4 0 0 0 2 0l5-5a1.4 1.4 0 0 0 0-2Z"/><circle cx="7.5" cy="7.5" r="1.2"/>' },
    // guides & info
    '/pages/how-ai-website-design-works': { c: '#1D5CFF', p: '<circle cx="5" cy="12" r="2.4"/><circle cx="19" cy="6" r="2.4"/><circle cx="19" cy="18" r="2.4"/><path d="m7.3 10.9 9.4-3.7M7.3 13.1l9.4 3.7"/>' },
    '/blogs/guides': { c: '#0FB5A6', p: '<path d="M5 4a2 2 0 0 1 2-2h12v16H7a2 2 0 0 0-2 2Z"/><path d="M19 18v3M9 6h6M9 9.5h6"/>' },
    '/pages/free-ai-visibility-report': { c: '#F2A93B', p: '<path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8l-5-5Z"/><path d="M14 3v5h5"/><path d="m9 14 2 2 4-4"/>' },
    // about
    '/pages/contact': { c: '#1D5CFF', p: '<path d="M3 6h18v12H3Z"/><path d="m3 6 9 7 9-7"/>' },
    'sanctuarygrowthco.com': { c: '#047857', p: '<path d="M11 20a7 7 0 0 1-7-7c0-5 4-9 12-9 0 8-4 12-9 12Z"/><path d="M4 20c2.5-4 5.5-6 9-7"/>' },
    'luminaskinsanctuary.com': { c: '#6D28D9', p: '<path d="M12 3 13.8 8.2 19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8Z"/>' },
    // cities & counties (color = page accent, glyph = its map emblem)
    '/pages/web-design-fort-myers': { c: '#C2410C', p: '<path d="M12 21V11M12 11c0-3.4-2.6-5.6-6-6 .4 3.4 2.6 6 6 6ZM12 11c0-3.4 2.6-5.6 6-6-.4 3.4-2.6 6-6 6Z"/><path d="M6 21h12"/>' },
    '/pages/web-design-cape-coral': { c: '#0369A1', p: '<path d="M3 20h18M4 16h16M6 12h12M4 16V9M20 16V9M12 12V4"/><circle cx="12" cy="4" r="1.4"/>' },
    '/pages/web-design-north-fort-myers': { c: '#BE123C', p: '<path d="M2 16.5h20M4.5 16.5c0-4.8 3.4-7.8 7.5-7.8s7.5 3 7.5 7.8M8.5 16.5v-3.4M15.5 16.5v-3.4M12 16.5v-4.4"/>' },
    '/pages/web-design-fort-myers-beach': { c: '#0891B2', p: '<path d="M3 18.5h18l-2.4 3H5.4ZM12 18.5V3.5M12 8.5l6 5h-6"/><path d="M12 18.5H5.5l6.5-7"/>' },
    '/pages/web-design-sanibel': { c: '#A16207', p: '<path d="M12 20.5c-5.2 0-8.5-4-8.5-8.4A8.5 8.5 0 0 1 20.5 12c0 4.4-3.3 8.5-8.5 8.5Z"/><path d="M12 20.5V4M12 20.5 5.4 7.6M12 20.5l6.6-12.9M12 20.5 3.9 12.4M12 20.5l8.1-8.1"/>' },
    '/pages/web-design-estero': { c: '#9D174D', p: '<path d="M3.5 20.5V13h4.2v7.5M9.7 20.5V8.5h4.6v12M16.3 20.5V4h4.2v16.5M2 20.5h20"/>' },
    '/pages/web-design-bonita-springs': { c: '#047857', p: '<circle cx="17.5" cy="6" r="2.6"/><path d="M2.5 14c2.1-2 4.2-2 6.3 0s4.2 2 6.3 0 4.2-2 6.4 0M2.5 18.5c2.1-2 4.2-2 6.3 0s4.2 2 6.3 0 4.2-2 6.4 0"/>' },
    '/pages/web-design-lehigh-acres': { c: '#4D7C0F', p: '<path d="M3 3h7v7H3zM14 3h7v7h-7zM3 14h7v7H3zM14 14h7v7h-7z"/><path d="M17.5 21v-3.2M16 17.8h3"/>' },
    '/pages/web-design-punta-gorda': { c: '#B45309', p: '<path d="M3.5 18.5h17l-2.3 3H5.8ZM12.5 16.5V2.8l6.4 13.7h-6.4ZM10.8 16.5H5.2l5.6-8.2"/>' },
    '/pages/web-design-port-charlotte': { c: '#0D9488', p: '<path d="M2.5 12.2c3-3.9 6.9-5.9 10.8-5.9 3 0 5 2 5 5.9s-2 5.9-5 5.9c-3.9 0-7.8-2-10.8-5.9Z"/><path d="m18.3 9 3.2-2.4v11.2L18.3 15.4"/>' },
    '/pages/web-design-babcock-ranch': { c: '#15803D', p: '<path d="M12 21v-6.5M12 14.5c0-3.6-2.4-6.4-6-7 .3 3.9 2.5 6.6 6 7ZM12 14.5c0-3.6 2.4-6.4 6-7-.3 3.9-2.5 6.6-6 7Z"/><path d="M4 21h16"/>' },
    '/pages/web-design-naples': { c: '#6D28D9', p: '<circle cx="12" cy="6.5" r="3"/><path d="M3 14h18M6.5 14v6M10 14v6M14 14v6M17.5 14v6"/>' },
    '/pages/web-design-lee-county': { c: '#9A3412', p: '<path d="M12 3 5 5.6v5.9c0 4.3 2.9 8.2 7 9.5 4.1-1.3 7-5.2 7-9.5V5.6L12 3Z"/><path d="M12 16v-4M12 12c0-2 1.6-3.4 3.6-3.4M12 12c0-2-1.6-3.4-3.6-3.4"/>' },
    '/pages/web-design-collier-county': { c: '#5B21B6', p: '<path d="M12 3 5 5.6v5.9c0 4.3 2.9 8.2 7 9.5 4.1-1.3 7-5.2 7-9.5V5.6L12 3Z"/><path d="M8.5 13.5c2-2.2 5-2.2 7 0M9.5 10.2h.01M14.5 10.2h.01"/>' },
    '/pages/web-design-charlotte-county': { c: '#155E75', p: '<path d="M12 3 5 5.6v5.9c0 4.3 2.9 8.2 7 9.5 4.1-1.3 7-5.2 7-9.5V5.6L12 3Z"/><path d="M7.5 14.5h9M9 14.5c0-3 1.4-5 3-5s3 2 3 5"/>' },
    '/pages/web-design-southwest-florida': { c: '#1D5CFF', p: '<circle cx="12" cy="8" r="4"/><path d="M2 16c2.2-2 4.4-2 6.6 0s4.4 2 6.6 0 4.4-2 6.8 0M2 20c2.2-2 4.4-2 6.6 0s4.4 2 6.6 0 4.4-2 6.8 0"/>' }
  };
  var DEF = { c: '#1D5CFF', p: '<path d="M5 12h13M13 6l6 6-6 6"/>' };

  function iconFor(href) {
    if (!href) return DEF;
    if (A[href]) return A[href];
    var clean = href.split('?')[0].replace(/\/$/, '');
    if (A[clean]) return A[clean];
    for (var k in A) { if (k.indexOf('.com') > -1 && href.indexOf(k) > -1) return A[k]; }
    return DEF;
  }
  function svg(ic) {
    return '<svg class="aiw-dd__ico" viewBox="0 0 24 24" width="18" height="18" fill="none" ' +
      'stroke="' + ic.c + '" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" ' +
      'aria-hidden="true" focusable="false">' + ic.p + '</svg>';
  }

  function flatten() {
    document.querySelectorAll('.menu-list__list-item[slot="more"]').forEach(function (li) { li.style.display = 'none'; });
    document.querySelectorAll('.menu-list .menu-list__submenu-inner').forEach(function (inner) {
      if (inner.querySelector('.aiw-dd')) return;
      var seen = {}, links = [];
      inner.querySelectorAll('a').forEach(function (a) {
        var href = a.getAttribute('href'), text = (a.textContent || '').trim();
        if (!href || !text || seen[href + '|' + text]) return;
        seen[href + '|' + text] = 1;
        links.push({ href: href, text: text, current: a.getAttribute('aria-current') });
      });
      if (!links.length) return;
      var ul = document.createElement('ul');
      ul.className = 'aiw-dd';
      links.forEach(function (l) {
        var li = document.createElement('li'), a = document.createElement('a');
        a.className = 'aiw-dd__link';
        a.href = l.href;
        if (l.current) a.setAttribute('aria-current', l.current);
        a.innerHTML = svg(iconFor(l.href)) + '<span>' + l.text.replace(/&/g, '&amp;').replace(/</g, '&lt;') + '</span>';
        li.appendChild(a); ul.appendChild(li);
      });
      inner.innerHTML = '';
      inner.appendChild(ul);
    });
  }

  // SEO: the homepage carries a generic hidden <h1>Ai Website Design</h1> from the
  // theme header on top of the real hero H1. Downgrade the header one to a <p> so
  // each page has exactly one H1 (the keyword-rich hero/title).
  function fixH1() {
    var hs = document.querySelectorAll('#header-component h1, header .header h1');
    hs.forEach(function (h) {
      if (h.dataset.aiwDowngraded) return;
      var p = document.createElement('p');
      p.className = h.className;
      p.setAttribute('data-aiw-downgraded', '1');
      p.innerHTML = h.innerHTML;
      h.parentNode.replaceChild(p, h);
    });
  }

  function run() { try { flatten(); } catch (e) {} try { fixH1(); } catch (e) {} }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  setTimeout(run, 400); setTimeout(run, 1200);
  var hdr = document.querySelector('#header-component') || document.body;
  if (window.MutationObserver && hdr) {
    var mo = new MutationObserver(function () { run(); });
    mo.observe(hdr, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 5000);
  }
})();
